exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/core-js/library/modules/_object-gops.js
// module id = 345
// module chunks = 0